import { store } from '../../../core/Store';
import { IAdress, IPersonalInfo } from '../../../models/PersonalInfo';
import {
	Actions,
	defaultPersonalInfo,
	defaultPersonalInfoErrors,
	defaultPersonalInfoRAdressErrors,
} from './reducer';
import * as Selectors from './selectors';
import * as Validate from './validate';
import * as Api from './api';
import * as Dialogs from './dialogs';
import { ErrorManager, defaultErrorObject } from '@react_components/errors';
import {
	IFormSaveDataResponse,
	ISaveAddress,
} from '../../../models/FormSaveData';
import { AFetchError } from '../../../core/aFetch';
import { IApiError } from '../../../models/Global';
import * as DictionariesRisksSelectors from '../../data/dictionaries/risks/selectors';
import { gotoPage } from '../../../utils/gotoPage';
import { Routing } from '../../../core/Routing';

export { Actions, Selectors, Validate, Dialogs };

export const promptNext = () => {
	const state = store.getState();
	const canOpen = Selectors.getCanOpenStage1Modal(state);
	const startDate = Selectors.getStartDate(state);

	if (!canOpen) {
		store.dispatch(Actions.setShowStage1Error(true));
		const termError = Selectors.getTermError(store.getState());
		const sectionsError = Selectors.getSectionsError(store.getState());

		const errMsg: string[] = [];

		termError && errMsg.push(termError);
		sectionsError && errMsg.push(sectionsError);

		Dialogs.pushFormErrors(errMsg.reverse());

		const tempAnchor = document.createElement('a');
		tempAnchor.href = startDate
			? '#form-stage1-risks'
			: '#form-stage1-term';
		tempAnchor.click();

		return;
	}

	Dialogs.pushPromptNext();
};

export const submitStep2 = () => {
	const state = store.getState();
	const canSave = Selectors.getCanSave(state);
	const isLoaded = Selectors.getIsLoaded(state);

	if (!isLoaded) {
		return;
	}

	if (!canSave) {
		store.dispatch(Actions.setShowStage2Error(true));

		const formError = Selectors.getFormError(store.getState());
		const consentsError = Selectors.getConsentsError(store.getState());
		const vereficationCodeError = Selectors.getVereficationCodeError(
			store.getState()
		);

		const tempAnchor = document.createElement('a');
		const errMsg: string[] = [];

		if (vereficationCodeError) {
			tempAnchor.href = '#form-stage2-code';
			errMsg.push(vereficationCodeError);
		}

		if (consentsError) {
			tempAnchor.href = '#form-stage2-consents';
			errMsg.push(consentsError);
		}

		if (formError) {
			tempAnchor.href = '#form-stage2-form';
			errMsg.push(formError);
		}

		tempAnchor.click();
		Dialogs.pushFormErrors(errMsg.reverse());

		return;
	}

	store.dispatch(Actions.setIsLoaded(false));

	saveFull()
		.then((res) => {
			store.dispatch(Actions.setPaywallUrl(res.paywallUrl || null));
			store.dispatch(Actions.setFormSuccess(true));
			gotoPage(Routing.main.formSuccess);
			store.dispatch(Actions.setIsLoaded(true));
		})
		.catch((err: AFetchError<IApiError[]>) => {
			mapSaveFullError(err.data);
			store.dispatch(Actions.setFormSuccess(false));
			store.dispatch(Actions.setPaywallUrl(null));
			store.dispatch(Actions.setIsLoaded(true));
		});
};

const mapSaveFullError = (apiErrors: IApiError[]) => {
	const state = store.getState();
	const rAdressErrors = { ...Selectors.getPersonalInfoRAdressErrors(state) };
	const personalInfoErrors = { ...Selectors.getPersonalInfoErrors(state) };
	let tokenError = Selectors.getVereficationCodeDisplayError(state);

	const personalInfoErrorsKeys = Object.keys(personalInfoErrors);
	const globalErrorsContent: string[] = [];

	apiErrors.forEach((err) => {
		// global
		if (!err.fieldName) {
			globalErrorsContent.push(err.errorMessage);
			return;
		}

		// form
		if (personalInfoErrorsKeys.includes(err.fieldName)) {
			personalInfoErrors[
				err.fieldName as keyof typeof personalInfoErrors
			] = err.errorMessage;
		}

		// rAdress
		if (err.fieldName.includes('residentalAddress_')) {
			const fieldName = err.fieldName.slice('residentalAddress_'.length);
			rAdressErrors[fieldName as keyof typeof rAdressErrors] =
				err.errorMessage;
		}

		// verify token
		if (err.fieldName.includes('token')) {
			tokenError = err.errorMessage;
		}
	});

	// display global errors
	if (globalErrorsContent.length > 0) {
		ErrorManager.pushError({
			...defaultErrorObject,
			content: (
				<div>
					{globalErrorsContent.map((el) => (
						<p key={el}>{el}</p>
					))}
				</div>
			),
		});
	}

	store.dispatch(Actions.setPersonalInfoErrors(personalInfoErrors));
	store.dispatch(Actions.setPersonalInfoRAdressErrors(rAdressErrors));
	store.dispatch(Actions.setVereficationCodeError(tokenError));
};

const saveFull = () => {	
	return new Promise<IFormSaveDataResponse>((resolve, reject) => {
		const state = store.getState();
		const personalInfo = Selectors.getPersonalInfo(state);
		const consentsStep1 = Selectors.getConsentsStep1(state);
		const consentsStep2 = Selectors.getConsentsStep2(state);
		const risks = Selectors.getSelectedRisksIds(state);
		const startDate = Selectors.getStartDate(state);
		const vereficationCode = Selectors.getVereficationCode(state);
		const hasBusiness = Selectors.getHasBusiness(state);

		Validate.validateForm();

		if (
			!personalInfo ||
			!personalInfo.email ||
			!personalInfo.firstName ||
			!personalInfo.lastName ||
			!personalInfo.phone ||
			!personalInfo.residentalAddress ||
			!personalInfo.residentalAddress.postalCode ||
			!personalInfo.residentalAddress.city ||
			!startDate
		) {
			return;
		}

		const residentalAddress: ISaveAddress = {
			street: personalInfo.residentalAddress.street || null,
			houseNo: personalInfo.residentalAddress.houseNo,
			appartmentNo: personalInfo.residentalAddress.appartmentNo || null,
			postalCode: personalInfo.residentalAddress.postalCode,
			city: personalInfo.residentalAddress.city,
		};

		Api.saveFull({
			email: personalInfo.email,
			firstName: personalInfo.firstName,
			lastName: personalInfo.lastName,
			pesel: personalInfo.pesel,
			phone: personalInfo.phone,

			startDate: startDate,

			residentalAddress,

			risks: [...risks, ...getExtendedIdRisk()],
			consents: [...consentsStep1, ...consentsStep2],

			token: vereficationCode,

			businessName: hasBusiness ? personalInfo.businessName : null,
			nip: hasBusiness ? personalInfo.nip : null,
		})
			.then((res) => {
				resolve(res);
			})
			.catch((err: AFetchError) => {
				Dialogs.pushGenericFailSave();
				reject(err);
			});
	});
};

export const resendOwuMail = () => {
	sendOwuMail(true);
	Dialogs.pushResendCode();
};

export const sendOwuMail = (forceSending = false) => {
	return new Promise((resolve, reject) => {
		const state = store.getState();
		const userPersonalInfo = Selectors.getPersonalInfo(state);
		const selectedRisksIds = Selectors.getSelectedRisksIds(state);

		if (!userPersonalInfo.email) {
			return;
		}

		Api.sendOwuMail({
			email: userPersonalInfo.email,
			risks: [...selectedRisksIds, ...getExtendedIdRisk()],
			forceSending: forceSending,
		})
			.then((res) => {
				resolve(res);
			})
			.catch((_err) => {
				ErrorManager.pushError({
					...defaultErrorObject,
					title: 'Błąd podczas próby wysłania e-mail',
					content:
						'Aplikacja napotkała błąd podczas próby wysłania e-mail z kodem werefikacyjnym.',
				});
				store.dispatch(Actions.setIsLoaded(false));
				reject();
			});
	});
};

// special rule: Risk id == 7 should be added if user choose to extend the OC to worldwide coverage
// risk id == 7 should never be in redux state, only added when sending the payload
const getExtendedIdRisk = () => {
	const state = store.getState();
	const extendedOcCoverageSelected =
		Selectors.getExtendedOcCoverageSelected(state);

	return extendedOcCoverageSelected ? [7] : [];
};

export const clearFullForm = () => {
	store.dispatch(Actions.setStartDate(''));
	store.dispatch(Actions.setVereficationCode(''));
	store.dispatch(Actions.setVereficationCodeError(''));
	store.dispatch(Actions.setFormAccessible(false));

	clearAllRisks();
	clearPersonalInfo();
	clearAllConsents();
};

export const clearPersonalInfoForm = () => {
	store.dispatch(Actions.setPersonalInfo(defaultPersonalInfo));
	store.dispatch(Actions.setPersonalInfoErrors(defaultPersonalInfoErrors));
	clearPersonalInfoRAdressErrors();
};

export const clearPersonalInfoRAdressErrors = () => {
	store.dispatch(
		Actions.setPersonalInfoRAdressErrors(defaultPersonalInfoRAdressErrors)
	);
};

export const setPersonalInfoField = <T,>(
	key: keyof Omit<
		IPersonalInfo,
		'correspondenceAddress' | 'residentalAddress' | 'plCitizenship'
	>,
	value: T
) => {
	const state = store.getState();
	const current = Selectors.getPersonalInfo(state);
	if (value === null || current[key] === value) return;
	store.dispatch(Actions.setPersonalInfo({ ...current, [key]: value }));
	Validate.validatePersonalInfoField(key);
};

export const setPersonalInfoAdressField = <T,>(
	key: keyof IAdress,
	value: T
) => {
	const state = store.getState();
	const current = Selectors.getPersonalInfo(state);
	const currentAdress = current.residentalAddress;

	if (value === null || (currentAdress && currentAdress[key] === value))
		return;

	store.dispatch(
		Actions.setPersonalInfo({
			...current,
			residentalAddress: { ...currentAdress!, [key]: value },
		})
	);
	Validate.validatePersonalInfoAdressField(key);
};

export const toggleSelectRisk = (
	riskId: number,
	group: 'oc' | 'kop' | 'nnw' | 'free'
) => {
	const state = store.getState();
	const selectedRisksIds = Selectors.getSelectedRisksIds(state);

	if (selectedRisksIds.includes(riskId)) {
		if (group === 'nnw') {
			const risksNnwKlauzule =
				DictionariesRisksSelectors.getRisksNnwKlauzule(state);
			const filtered = selectedRisksIds.filter(
				(el) => !risksNnwKlauzule.map((el) => el.riskId).includes(el)
			);

			store.dispatch(Actions.setSelectedRisksIds(filtered));
		}

		// deselecting OC risks -> remove id 21 and 22
		if (group === 'oc') {
			const filtered = selectedRisksIds.filter(
				(el) => el !== riskId && el !== 21 && el !== 22
			);

			store.dispatch(Actions.setSelectedRisksIds(filtered));

			return;
		}

		const selectedRisksIds2 = Selectors.getSelectedRisksIds(
			store.getState()
		);

		const filtered = selectedRisksIds2.filter((el) => el !== riskId);

		store.dispatch(Actions.setSelectedRisksIds(filtered));

		return;
	}

	if (group === 'oc') {
		const OCRisks = DictionariesRisksSelectors.getRisksOc(state);
		// jeśli jakikolwiek z oc risks jest już wybrany to clear chuja i zastępujemy go akutalnym
		const filtered = selectedRisksIds.filter(
			(el) => !OCRisks.map((el) => el.riskId).includes(el)
		);

		// if no OC selected risks -> reset Extended OC
		if (filtered.length === 0) {
			store.dispatch(Actions.setExtendedOcCoverageSelected(false));
		}

		store.dispatch(Actions.setSelectedRisksIds([...filtered, riskId]));
		return;
	}

	if (group === 'kop') {
		const KopRisks = DictionariesRisksSelectors.getRisksKop(state);
		const filtered = selectedRisksIds.filter(
			(el) => !KopRisks.map((el) => el.riskId).includes(el)
		);

		store.dispatch(Actions.setSelectedRisksIds([...filtered, riskId]));
		return;
	}

	if (group === 'nnw') {
		const NnwRisks = DictionariesRisksSelectors.getRisksNnw(state);
		const filtered = selectedRisksIds.filter(
			(el) => !NnwRisks.map((el) => el.riskId).includes(el)
		);

		// // if no selcted NNW risks -> clear all NNW klauzule risks
		// if (!filtered.some((el) => el >= 8 && el <= 15)) {
		// 	// const risksNnwKlauzule =
		// 	// 	DictionariesRisksSelectors.getRisksNnwKlauzule(state);

		// 	const final = filtered.filter((el) => el < 16);

		// 	store.dispatch(Actions.setSelectedRisksIds([...final, riskId]));
		// 	return;
		// }

		store.dispatch(Actions.setSelectedRisksIds([...filtered, riskId]));
		return;
	}

	if (group === 'free') {
		store.dispatch(
			Actions.setSelectedRisksIds([...selectedRisksIds, riskId])
		);
	}
};

export const clearSelectedOCRisks = () => {
	const state = store.getState();
	const selectedRisksIds = Selectors.getSelectedRisksIds(state);
	const OCRisks = DictionariesRisksSelectors.getRisksOc(state);

	const filtered = selectedRisksIds.filter(
		(el) =>
			!OCRisks.map((el) => el.riskId).includes(el) &&
			el !== 21 &&
			el !== 22
	);

	store.dispatch(Actions.setSelectedRisksIds(filtered));
};

export const clearSelectedKOPRisks = () => {
	const state = store.getState();
	const selectedRisksIds = Selectors.getSelectedRisksIds(state);
	const KOPRisks = DictionariesRisksSelectors.getRisksKop(state);

	const filtered = selectedRisksIds.filter(
		(el) => !KOPRisks.map((el) => el.riskId).includes(el)
	);

	store.dispatch(Actions.setSelectedRisksIds(filtered));
};

export const toggleSelectOCExtendedRisk = (selected: boolean) => {
	store.dispatch(Actions.setExtendedOcCoverageSelected(selected));
};

export const clearSelectedNNWRisks = () => {
	const state = store.getState();
	const selectedRisksIds = Selectors.getSelectedRisksIds(state);
	const NNWRisks = DictionariesRisksSelectors.getRisksNnw(state);
	const NNWKlauzuleRisks =
		DictionariesRisksSelectors.getRisksNnwKlauzule(state);

	const filtered = selectedRisksIds.filter(
		(el) =>
			!NNWRisks.map((el) => el.riskId).includes(el) &&
			!NNWKlauzuleRisks.map((el) => el.riskId).includes(el)
	);

	store.dispatch(Actions.setSelectedRisksIds(filtered));
};

export const clearAllRisks = () => {
	store.dispatch(Actions.setSelectedRisksIds([]));
};

export const clearPersonalInfo = () => {
	store.dispatch(Actions.setPersonalInfo(defaultPersonalInfo));
};

export const clearAllConsents = () => {
	const state = store.getState();

	const consentsStep1 = Selectors.getConsentsStep1(state);
	const consentsStep2 = Selectors.getConsentsStep2(state);

	const consentsStep1Reset = consentsStep1.map((el) => ({
		...el,
		consentState: false,
	}));
	const consentsStep2Reset = consentsStep2.map((el) => ({
		...el,
		consentState: false,
	}));

	store.dispatch(Actions.setConsentsStep1(consentsStep1Reset));
	store.dispatch(Actions.setConsentsStep2(consentsStep2Reset));
};

export const flipConsent = (id: number, type: 'step1' | 'step2') => {
	const state = store.getState();

	if (type === 'step1') {
		const consentsState = Selectors.getConsentsStep1(state);

		const mapped = consentsState.map((el) => {
			if (el.consentId === id) {
				return {
					...el,
					consentState: !el.consentState,
				};
			}
			return el;
		});

		store.dispatch(Actions.setConsentsStep1(mapped));
		return;
	}
	if (type === 'step2') {
		const consentsState = Selectors.getConsentsStep2(state);

		const mapped = consentsState.map((el) => {
			if (el.consentId === id) {
				return {
					...el,
					consentState: !el.consentState,
				};
			}
			return el;
		});

		store.dispatch(Actions.setConsentsStep2(mapped));
		return;
	}
};

export const toggleAllStep1Consents = () => {
	const state = store.getState();
	const consentsStep1 = Selectors.getConsentsStep1(state);

	if (consentsStep1.every((el) => el.consentState)) {
		const mapped = consentsStep1.map((el) => ({
			...el,
			consentState: false,
		}));
		store.dispatch(Actions.setConsentsStep1(mapped));
		return;
	}

	const mapped = consentsStep1.map((el) => ({ ...el, consentState: true }));

	store.dispatch(Actions.setConsentsStep1(mapped));
};

export const toggleAllStep2Consents = () => {
	const state = store.getState();
	const consentsStep2 = Selectors.getConsentsStep2(state);

	if (consentsStep2.every((el) => el.consentState)) {
		// unset all
		const mapped = consentsStep2.map((el) => ({
			...el,
			consentState: false,
		}));
		store.dispatch(Actions.setConsentsStep2(mapped));
		return;
	}

	const mapped = consentsStep2.map((el) => ({ ...el, consentState: true }));

	store.dispatch(Actions.setConsentsStep2(mapped));
};
